module.exports = __webpack_public_path__ + "img/OCP_Crest_Large.e69955d9.png";